export function compareValues(value1: any, value2: any) {
  if (!value1 === true && !value2 === true) return true;

  if (value1 === value2) return true;

  return false;
}
